import { useState } from "react";
import { withRouter } from "react-router";
import { useLocation } from "react-router-dom";
import { SERVER_SETUP } from "common/src/helpers/constants";
import { Trans } from "react-i18next";
import { StyledPageWrap } from "common/src/styledComponents/StyledWarning";

const Error = (props) => {
  let [serverSetup] = useState(sessionStorage.getObject(SERVER_SETUP));
  let currentLocation = useLocation();
  // const { i18n } = useTranslation("");
  // const baseUrl = "/" + i18n.language;

  console.log("serverSetup:", serverSetup);
  console.log("props:", props);
  console.log("currentLocation:", currentLocation);

  return (
    <>
      <StyledPageWrap>
        <h1>
          <Trans i18nKey={"label_errorpage_title"}></Trans>
        </h1>
        <p>
          <Trans i18nKey={"label_errorpage_content"}></Trans>
        </p>
      </StyledPageWrap>
    </>
  );
};

export default withRouter(Error);
